export default __webpack_public_path__ + "static/media/cooker.bcfc83ed.jpg";